// extracted by css-extract-rspack-plugin
export default {"warning":"CancelModal__warning--_DSAy","warningTitle":"CancelModal__warningTitle--Icdso","cancelButton":"CancelModal__cancelButton--i_20U"};